import "./LessonPlans.css";
import { useContext, useMemo, useState } from "react";
import axios from "axios";
import Moment from "react-moment";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";

import PopupModal, { PopupButton } from "../Modal/Modal";

import { LessonPlanAPIs } from "../api";

import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  Close,
  RemoveRedEye,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Edit,
} from "@material-ui/icons";
import { IconButton, Collapse, Box } from "@mui/material";
import { MenuItem } from "@material-ui/core";
import EditLessonPlanModal from "../Modal/EditPlan";

import { useLessonPlans } from "../../../context/LessonPlanProvider";
import { GlobalContext } from "../../../context/GlobalState";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: "auto",
  },
  formControl: {
    minWidth: 280,
    margin: 0,
    marginBottom: "-16px",
  },
  selectBoxStyle: {
    padding: "1px 2px !important",
    border: "1px solid black !important",
    margin: "0",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
  },
  datePickerStyle: {
    backgroundColor: "transparent",
  },
  tableRow: {
    textDecoration: "none",
    fontSize: "1rem",
    "&:hover": {
      backgroundColor: "#A6EDE5 !important",
    },
  },
}));

function Cell({ children }) {
  return (
    <TableCell
      align="center"
      style={{ fontWeight: "bold", minWidth: "130px", fontSize: "1.1rem" }}
    >
      {children}
    </TableCell>
  );
}

function LessonPlan({ staffRole, group, setLessonPlan }) {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const { grades, lessonPlans, setLessonPlans } = useLessonPlans();
  const { userDetails, assignedGrades } = useContext(GlobalContext);

  function syncLessonPlan(planId, lessonPlan) {
    const index = lessonPlans.findIndex((plan) => plan._id === planId);
    if (index < 0) return;
    lessonPlans[index] = {
      ...lessonPlans[index],
      ...lessonPlan //override updated fields
    }
    setLessonPlans([...lessonPlans]);
  }

  const action = useMemo(() => {
    return staffRole === "teacher" ? "edit" : "download";
  }, [staffRole, group]);

  return (
    <>
      {/* Main row */}
      <TableRow style={{ width: "fit-content" }} className={classes.tableRow}>
        {/* Teacher */}
        {staffRole === "teacher" ? null : (
          <TableCell align="center" className={classes.tableRow}>
            {group[0]?.teacherId?.name || ""}
          </TableCell>
        )}
        {/* Date */}
        <TableCell align="center" className={classes.tableRow}>
          <Moment format="DD-MM-YYYY">{group[0]?.startDate}</Moment>
        </TableCell>

        {/* View Action */}
        <TableCell align="center" className={classes.tableRow}>
          <RemoveRedEye
            style={{ width: "25px", color: "#4fb8ad", cursor: "pointer" }}
            onClick={() =>
              history.push(
                `/lessonplans/edit?teacherId=${group[0]?.teacherId?._id}&startDate=${group[0]?.startDate}&action=${action}&view=landscape`
              )
            }
          />
        </TableCell>
        {/* Expand Arrow on right */}
        <TableCell align="center">
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
      </TableRow>

      {/* Collapsible subrows */}
      <TableRow>
        <TableCell
          colSpan={staffRole === "teacher" ? 3 : 4}
          style={{ paddingBottom: 0, paddingTop: 0 }}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <Cell>Period</Cell>
                    <Cell>Grade</Cell>
                    <Cell>Subject</Cell>
                    <Cell>Chapter</Cell>
                    <Cell>Topic</Cell>
                    <Cell>Sub Topic</Cell>
                    {staffRole === "teacher" ? <Cell>Action</Cell> : ""}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {group.map((item, i) => (
                    <>
                      <TableRow key={i} className={classes.tableRow}>
                        <TableCell className={classes.tableRow} align="center">
                          {item.time || "N/A"}
                        </TableCell>
                        <TableCell align="center" className={classes.tableRow}>
                          {`${item?.sectionId?.grade || ""}-${
                            item?.sectionId?.section
                          }`}
                        </TableCell>
                        <TableCell className={classes.tableRow} align="center">
                          {item.subjectId?.name || ""}
                        </TableCell>
                        <TableCell className={classes.tableRow} align="center">
                          {item?.chapterId?.name || item.customChapter || ""}
                        </TableCell>
                        <TableCell className={classes.tableRow} align="center">
                          {item?.topicId?.name || item.customTopic || ""}
                        </TableCell>
                        <TableCell className={classes.tableRow} align="center">
                          {item?.moduleId?.name || item.customModule || ""}
                        </TableCell>
                        <TableCell
                          className={classes.tableRow}
                          align="center"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {staffRole === "teacher" && (
                            <>
                              <MenuItem
                                data-bs-toggle="modal"
                                data-bs-target={`#edit_${item._id}`}
                                value="url"
                                style={{ width: "fit-content" }}
                              >
                                <Edit />
                              </MenuItem>
                              <Close
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => setLessonPlan(item)}
                              />
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                      <EditLessonPlanModal
                        planId={item._id}
                        grades={grades}
                        assignedClasses={assignedGrades.grades}
                        syncLessonPlan={syncLessonPlan}
                        userId={userDetails.userId}
                        formData={{
                          gradeName: item?.sectionId?.grade || "",
                          sectionName: item?.sectionId?.section || "",
                          subjectId: item?.subjectId?._id || undefined,
                          chapterName:
                            item?.chapterId?.name || item?.customChapter || "",
                          chapterId: undefined,
                          topicName:
                            item?.topicId?.name || item?.customTopic || "",
                          topicId: undefined,
                          moduleName: item?.customModule || "",
                          createMethod: item?.createMethod || "manual",
                          time: item?.time || "",
                          level: item?.level || "Level 1",
                          classesTeaching: item?.classesTeaching || "",
                          fromDate: item?.startDate
                            ? new Date(item.startDate)
                            : null,
                        }}
                      />
                    </>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

function LessonPlans(props) {
  const classes = useStyles();
  const [popup, setPopup] = useState({});
  const [progress, setProgress] = useState(false);
  const [lessonPlan, setLessonPlan] = useState(null);

  function deleteLessonPlan() {
    if (progress) return;
    setProgress(true);
    axios
      .delete(LessonPlanAPIs.deleteLessonPlan(props.userId, lessonPlan._id), {
        headers: {
          token: localStorage.getItem("authToken"),
        },
        validateStatus: () => true,
      })
      .then((res) => {
        if (res.data.status !== "success")
          throw { message: res.data.message || "Oops Failed to delete" };

        const lps = props.lessonPlans.filter(
          (lp) => `${lp._id}` !== `${lessonPlan._id}`
        );
        props.setLessonPlans([...lps]);

        setLessonPlan(null);
        setPopup({
          open: true,
          status: "Success",
          message: "Lesson plan deleted",
        });
      })
      .catch((err) => {
        setPopup({ open: true, status: "Error", message: err.message });
      })
      .finally(() => setProgress(false));
  }

  return (
    <div
      className={`${
        props.lessonPlans.length || props.grades ? "col-sm-10" : "col-sm-12"
      } mt-lg-0`}
    >
      <section className="taskFilter">
        <div
          className="flex"
          style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
        ></div>
      </section>
      <TableContainer component={Paper} className="mt-2">
        <Table className={classes.table} aria-label="lesson plans table">
          <TableHead>
            <TableRow>
              {props.staffRole === "teacher" ? null : <Cell>Teacher</Cell>}
              <Cell>Date</Cell>
              <Cell>Action</Cell>
              <Cell /> {/* expand/collapse arrow on right */}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.groupedPlans.map((plan, index) => (
              <LessonPlan
                key={plan.map((p) => p?._id).join("-")}
                staffRole={props.staffRole}
                setLessonPlan={setLessonPlan}
                group={plan}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!props.loading && !props.lessonPlans.length ? (
        <p
          style={{
            margin: "50px auto",
            textAlign: "center",
            fontSize: "1.1rem",
          }}
        >
          No Data Found
        </p>
      ) : null}
      {props.loading ? (
        <div style={{ width: "fit-content", margin: "50px auto" }}>
          <CircularProgress />
        </div>
      ) : null}
      <PopupModal
        open={lessonPlan ? true : false}
        heading="Delete"
        message="Are you sure you want to this plan?"
      >
        <PopupButton
          onClick={() => {
            if (progress) return;
            setLessonPlan(null);
          }}
        >
          {" "}
          Cancel
        </PopupButton>
        <PopupButton
          onClick={deleteLessonPlan}
          style={{
            background: "#f13a3a",
            color: "#ffffff",
          }}
        >
          {progress ? "Deleting" : "Delete"}
        </PopupButton>
      </PopupModal>
      <PopupModal
        open={popup.open}
        heading={popup.status}
        message={popup.message}
      >
        <PopupButton onClick={() => setPopup({})}>Close</PopupButton>
      </PopupModal>
    </div>
  );
}

export default LessonPlans;
